import { z } from 'zod/v3'

import { m } from '@/lib/paraglide/messages'

/** Giới hạn khớp server (usecase/shop/guide_videos.go). */
export const GUIDE_TITLE_MAX = 200
export const GUIDE_GROUP_MAX = 100
export const GUIDE_DESCRIPTION_MAX = 1000

// Ô video / ảnh bìa giữ id thư viện (gửi server) kèm url + tên để hiện xem trước;
// tên ô trùng tên server trả trong params.field để lỗi server hiện đúng chỗ.
export const createShopGuideVideoSchema = () =>
    z.object({
        title: z
            .string()
            .trim()
            .min(1, m.guideVideo_error_title_required())
            .max(
                GUIDE_TITLE_MAX,
                m.guideVideo_error_title_too_long({ max: GUIDE_TITLE_MAX }),
            ),
        description: z.string().max(
            GUIDE_DESCRIPTION_MAX,
            m.guideVideo_error_description_too_long({
                max: GUIDE_DESCRIPTION_MAX,
            }),
        ),
        group_name: z
            .string()
            .trim()
            .min(1, m.guideVideo_error_group_required())
            .max(
                GUIDE_GROUP_MAX,
                m.guideVideo_error_group_too_long({ max: GUIDE_GROUP_MAX }),
            ),
        video_media_id: z.string().min(1, m.guideVideo_error_video_required()),
        video_url: z.string(),
        video_name: z.string(),
        poster_media_id: z.string().nullable(),
        poster_url: z.string().nullable(),
        duration_seconds: z.number().int().nonnegative().nullable(),
        active: z.boolean(),
    })

export type ShopGuideVideoForm = z.infer<
    ReturnType<typeof createShopGuideVideoSchema>
>
